export const listingTypeOptions=[
    {value: '', label: '',},
    {value: 'Szanto', label: 'Szántó',},
    {value: 'Beltelek', label: 'Beltelek',},
    {value: 'Kaszalo', label: 'Kaszáló',},
    {value: 'Erdo', label: 'Erdő',},
    {value: 'Tombhazlakas', label: 'Tömbházlakás',},
    {value: 'Garzon', label: 'Garzon',},
    {value: 'Csaladihaz', label: 'Családiház',},
    {value: 'Hetvegihaz', label: 'Hétvégiház',},
    {value: 'Kulcsoshaz', label: 'Kulcsosház',}, 
    {value: 'Udvarhaz', label: 'Udvarház',},
    {value: 'Kastely', label: 'Kastély',},
    {value: 'Hotel', label: 'Hotel',},
    {value: 'Panzio', label: 'Panzió',},
    {value: 'Kiadoszoba', label: 'Kiadó szoba',},
    {value: 'Iroda', label: 'Iroda',},   
    {value: 'Ipariepulet', label: 'Ipari épület',},
    {value: 'Kereskedelmiingatlan', label: 'Kereskedelmi ingatlan',},    
    {value: 'Egyeb', label: 'Egyéb',},
]

export const propertyStatusOptions=[
    {value: '', label: '',},
    {value: 'Elado', label: 'Eladó',},
    {value: 'Kiado', label: 'Kiadó',}, 
    {value: 'Hosszutavonberelheto', label: 'Hosszútávon bérelhető',},
    {value: 'Zarva', label: 'Zárva',},
    {value: 'Tervezett', label: 'Tervezett',},
    {value: 'Epulofelben', label: 'Épülőfélben',},    
]

export const rentalFrequencyOptions=[
    {value: '', label: '',},
    {value: 'Month', label: 'Havi',},
    {value: 'Napi', label: 'Napi',},
    {value: 'Week', label: 'Heti',},
]

export const CategoryLabels = (t) => ({
    'Piacihirdetesek': t('Map.CategoryLabels.Piacihirdetesek'),
    'Latnivalok': t('Map.CategoryLabels.Latnivalok'),
    'Epitettorokseg': t('Map.CategoryLabels.Epitettorokseg'),
    'Asvanyviz': t('Map.CategoryLabels.Asvanyviz'),
    'Szallas': t('Map.CategoryLabels.Szallas'),
    'Sport': t('Map.CategoryLabels.Sport'),
    'Tortenelem': t('Map.CategoryLabels.Tortenelem'),
});

export const KeyLabels = (t) => ({
    'Ingatlan': t('Map.KeyLabels.Ingatlan'),
    'Auto': t('Map.KeyLabels.Auto'),
    'Telisportfelszereles': t('Map.KeyLabels.Telisportfelszereles'),
    'Nyarisportfelszereles': t('Map.KeyLabels.Nyarisportfelszereles'),
    'Sajattermek': t('Map.KeyLabels.Sajattermek'),
    'Hosztel': t('Map.KeyLabels.Hosztel'),
    'kastely': t('Map.KeyLabels.kastely'),
    'Hotel': t('Map.KeyLabels.Hotel'),
    'Panzio': t('Map.KeyLabels.Panzio'),
    'Kiadoszoba': t('Map.KeyLabels.Kiadoszoba'),
    'Tombhazlakas': t('Map.KeyLabels.Tombhazlakas'),
    'Szallasreggelivel': t('Map.KeyLabels.Szallasreggelivel'),
    'Kemping': t('Map.KeyLabels.Kemping'),
    'Satortabor': t('Map.KeyLabels.Satortabor'),
    'kapolna': t('Map.KeyLabels.kapolna'),
    'templom': t('Map.KeyLabels.templom'),
    'var': t('Map.KeyLabels.var'),
    'motel': t('Map.KeyLabels.motel'),
    'udvarhaz': t('Map.KeyLabels.udvarhaz'),
    'Rovasirasepulet': t('SubMenu.RunicScripts'),
    'Neprajziepulet': t('SubMenu.Ethnographic'),
    'Egyhaziepulet': t('SubMenu.Spiritual'),
    'Foldtaniepulet': t('SubMenu.Geological'),
    'Novenyvilagepulet': t('SubMenu.Botanical'),
    'Asvanyvizepulet': t('SubMenu.MineralWater'),
    'Satoreskemping': t('Map.KeyLabels.Satoreskemping'),
    'Apartman': t('Map.KeyLabels.Apartman'),
    'Sizes': t('Map.KeyLabels.Sizes'),
    'Siberles': t('Map.KeyLabels.Siberles'),
    'Sifelvono': t('Map.KeyLabels.Sifelvono'),
    'Uszas': t('Map.KeyLabels.Uszas'),
    'Strand': t('Map.KeyLabels.Strand'),
    'Uszoda': t('Map.KeyLabels.Uszoda'),
    'Kofejto': t('Map.KeyLabels.Kofejto'),
    'Banya': t('Map.KeyLabels.Banya'),
    'Bezartbanya': t('Map.KeyLabels.Bezartbanya'),
    'Olajesgaz': t('Map.KeyLabels.Olajesgaz'),
    'Kilato': t('Map.KeyLabels.Kilato'),
    'Iszapvulkan': t('Map.KeyLabels.Iszapvulkan'),
    'Forras': t('Map.KeyLabels.Forras'),
    'termalforras': t('Map.KeyLabels.termalforras'),
    'termalviz': t('Map.KeyLabels.termalviz'),
    'Borviz': t('Map.KeyLabels.Borviz'),
    'Mofetta': t('Map.KeyLabels.Mofetta'),
    'Radioaktiv': t('Map.KeyLabels.Radioaktiv'),
    'Kenes': t('Map.KeyLabels.Kenes'),
    'Kakasborozda': t('Map.KeyLabels.Kakasborozda'),
    'Letelepedes': t('Map.KeyLabels.Letelepedes'),
    'Regesz': t('Map.KeyLabels.Regesz'),
    'Rovasemlek': t('Map.KeyLabels.Rovasemlek'),
    'Sipalya': t('Map.KeyLabels.Sipalya'),
    'Ski': t('Map.KeyLabels.Ski'),
    'StrandUszoda': t('Map.KeyLabels.StrandUszoda'),
});

// Tooltips
export const CategoryTooltips = {
    'Ingatlan': 'Piacihirdetesek',
    'Auto': 'Piacihirdetesek',
    'Telisportfelszereles': 'Piacihirdetesek',
    'Nyarisportfelszereles': 'Piacihirdetesek',
    'Sajattermek': 'Piacihirdetesek',
    'udvarhaz': 'Epitettorokseg',
    'kastely': 'Epitettorokseg',
    'kapolna': 'Epitettorokseg',
    'templom': 'Epitettorokseg',
    'var': 'Epitettorokseg',
    'motel': 'Szallas',
    'hosztel': 'Szallas',
    'hotel': 'Szallas',
    'hotel***': 'Szallas',
    'hotel****': 'Szallas',
    'satortabor': 'Szallas',
    'apartman': 'Szallas',
    'Szallasreggelivel': 'Szallas',
    'Szallásgyorsreggelivel': 'Szallas',
    'Kemping': 'Szallas',
    'Satoreskemping': 'Szallas',
    'Borviz': 'Asvanyviz',
    'Forras': 'Asvanyviz',
    'Termalforras': 'Asvanyviz',
    'termalviz': 'Asvanyviz',
    'Termalviz': 'Asvanyviz',
    'Mofetta': 'Asvanyviz',
    'Radioaktiv': 'Asvanyviz',
    'Kenes': 'Asvanyviz',
    'Sizes': 'Sport',
    'Siberles': 'Sport',
    'Sifelvono': 'Sport',
    'Uszas': 'Sport',
    'Strand': 'Sport',
    'Uszoda': 'Sport',
    'Sipalya': 'Sport',
    'Ski': 'Sport',
    'StrandUszoda': 'Sport',
    'Kakasborozda': 'Tortenelem',
    'Letelepedes': 'Tortenelem',
    'Regesz': 'Tortenelem',
    'Rovasemlek': 'Tortenelem',
};

// Admin labels
export const AdmLabels = (t) => ({
    'kozsegvaros': t('Map.Toolbox.kozsegvaros'),
    'telepules': t('Map.Toolbox.telepules'),
    'szek': t('Map.Toolbox.szek'),
    'megye': t('Map.Toolbox.megye'),
    'helynev': t('Map.Toolbox.helynev'),
    'folyovizek': t('Map.Toolbox.folyovizek'),
});

// Categories array
export const categories = {
    'Piacihirdetesek': ['Auto', 'Ingatlan', 'Nyarisportfelszereles', 'Sajattermek', 'Telisportfelszereles'],
    'Latnivalok': ['Egyhaziepulet', 'Foldtaniepulet', 'Neprajziepulet', 'Novenyvilagepulet'],
    'Epitettorokseg': [
        'kapolna', 'kastely', 'templom', 'udvarhaz', 'var',
    ],
    'Tortenelem': ['Kakasborozda', 'Letelepedes', 'Regesz', 'Rovasemlek'],
    'Asvanyviz': ['Borviz', 'Forras', 'Kenes', 'Mofetta', 'Radioaktiv', 'termalforras', 'termalviz'],
    'Szallas': ['Hosztel', 'Hotel', 'Panzio', 'Kiadoszoba', 'Tombhazlakas', 'Szallasreggelivel', 'Kemping', 'Satortabor', 'motel', 'udvarhaz', 'kastely', 'Satoreskemping', 'Apartman'],
    'Sport': ['Sipalya', 'Strand', 'Uszoda'],
};

// Admin layers
export const admlayers = {
    'megye': 'megye',
    'szek': 'szek',
    'kozsegvaros': 'kozsegvaros',
    'telepules': 'telepules',
    'helynev': 'helynev',
    'folyovizek': 'folyovizek',
};